<mat-toolbar class="header-versatile" [matMenuTriggerFor]="mainMenuHeader">
    <div>
        <mat-icon class="logo-icon" svgIcon="logo"></mat-icon>
        <span class="header-title" [matTooltip]="title">{{title}}</span>
        <mat-icon class="angle-icon" svgIcon="arrow_drop_down"></mat-icon>
    </div>
    <mat-menu #mainMenuHeader="matMenu" [overlapTrigger]="false"
        [class]="title == 'Dashboard' ? 'wide-menu' : 'narrow-menu'">

        <button mat-menu-item [hidden]="currentUrl | stringContains: 'Profile'" [routerLink]="['/Profile/EditProfile']">
            My Information</button>
        <button mat-menu-item *ngIf="currentUrl != '/' && (PDFAssignerRole | isInRole: true )" [routerLink]="['/']">
            Main Dashboard</button>
        <button mat-menu-item *ngIf="(!(currentUrl | stringContains: 'Admin')) && ((AdministratorRole | isInRole ) || (CategoryManagerRole | isInRole))"
            [routerLink]="[isNavigateToLicensePage ? '/Admin/License' : '/Admin/UsersTable']"
            (click)="onAdminClick()">Admin
            Panel</button>
        <button mat-menu-item [routerLink]="['/PdfAssigner']"
            *ngIf="!(currentUrl | stringContains: 'PdfAssigner') && ((PDFAssignerRole | isInRole) || (AdministratorRole | isInRole)) && isAllowedByLicense()">PDF
            Assigner</button>
        <button mat-menu-item (click)="onNavigateToHelpLink()"> Help</button>
        <button mat-menu-item (click)="onLogout()"> Log Out</button>
    </mat-menu>
</mat-toolbar>
